export default __webpack_public_path__ + "static/media/placeholder.6b1603f8.jpg";